
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/hooks/use-toast";

/**
 * Fetches all CV versions for a candidate
 */
export const fetchCVVersions = async (candidateId: string): Promise<Array<{name: string, created_at: string}>> => {
  try {

    const { data: resumeList, error: errorFetchResume } = await supabase.functions.invoke("get-candidate-resume", {
      body: {
        candidateId: candidateId
      }
    });

    if (resumeList === null) {
      return [];
    }

    if (errorFetchResume) {
      console.error("Error fetching resume list:", errorFetchResume);
      return [];
    }

    let versionFiles = [];


    // Check if there are any versioned CVs
    if (resumeList.resume.previousResumes.length > 0) {
      versionFiles = resumeList.resume.previousResumes.map((version: any) => ({
        name: version.name,
        created_at: version.created_at
      }));
    }

    console.log(versionFiles);

    return versionFiles;

  } catch (error) {
    console.error("Error in fetchCVVersions:", error);
    return [];
  }
};

/**
 * Gets a public URL for a specific CV version
 */
export const getCVVersionUrl = async (candidateId: string, versionName: string): Promise<string | null> => {

  const { data } = await supabase
    .storage
    .from('cvs')
    .getPublicUrl(`${candidateId}/cv/${versionName}`);
  
  return data?.publicUrl || null;

};

/**
 * Uploads a new CV and creates a version of the previous one if it exists
 */
export const uploadCV = async (
  candidateId: string, 
  file: File, 
  existingCvUrl: string | null,
  candidateName: string = ""
): Promise<string | null> => {

  try {   

    if (existingCvUrl) {
      let cleanName = existingCvUrl.split('cvs/')[1];
      await supabase
        .storage
        .from('cvs')
        .move(cleanName, `${candidateId}/cv/${new Date().getTime()}_${cleanName.split('/cv/')[1]}`)

    }
    
    // Upload the new CV with metadata
    const { error } = await supabase
      .storage
      .from('cvs')
      .upload(`${candidateId}/cv/${file.name}`, file, {
        upsert: false,
        contentType: file.type,
      });
    
    if (error) {
      console.error("Error uploading new CV:", error);
      throw error;
    }

    const { data: resumeList, error: errorFetchResume } = await supabase.functions.invoke("get-candidate-resume", {
      body: {
        candidateId: candidateId
      }
    });

    if (resumeList === null) {
      return "";
    }

    if (errorFetchResume) {
      console.error("Error fetching resume list:", errorFetchResume);
      return "";
    }

    return resumeList.resume.currentResume.publicUrl;
    
  } catch (error) {
    console.error("Error uploading CV:", error);
    throw error;
  }
};


/**
 * Detects if a URL is a PDF based on common patterns
 */
export const isPdfFile = (url: string | null): boolean => {
  if (!url) return false;
  
  // More comprehensive PDF detection
  return url.toLowerCase().endsWith('.pdf') || 
         url.toLowerCase().includes('content-type=application%2Fpdf') ||
         url.toLowerCase().includes('content-type=pdf');
};

/**
 * Checks if a CV file actually exists in storage
 */
export const checkCVExists = async (candidateId: string): Promise<boolean> => {
  try {
    
    const { data: resumeList, error: errorFetchResume } = await supabase.functions.invoke("get-candidate-resume", {
      body: {
        candidateId: candidateId
      }
    });

    console.log("checkCVExists", resumeList)

    if (resumeList === null) {
      return false;
    }

    return true;

  } catch (error) {
    console.error("Error in checkCVExists:", error);
    return false;
  }
};
